export function shuffle(array: any[]) {
  let temp, index;
  for (let i = array.length - 1; i > 0; i--) {
    index = Math.floor(Math.random() * array.length);
    temp = array[i];
    array[i] = array[index];
    array[index] = temp;
  }
  return array;
}
